import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/simp_in/step2';
import { Oui_TypeOuiNonNbCandidatReduitFNSSimple } from '../models/Oui_TypeOuiNonNbCandidatReduitFNSSimple';
@Component({
	selector: 'app-oui-type-oui-non-nb-candidat-reduitFNS-simple',
	templateUrl: './oui-type-oui-non-nb-candidat-reduitFNS-simple.component.html'
})
export class OuiTypeOuiNonNbCandidatReduitFNSSimpleComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Oui_TypeOuiNonNbCandidatReduitFNSSimple';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() oui: Oui_TypeOuiNonNbCandidatReduitFNSSimple;

	public step2 = new Step2();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
